import React from 'react';

// Option A — Top-down view of a dayan (treble tabla head)
// Outer body ring, dashed rim, syahi (filled centre patch), inner ring, 4 lacing dots
export default function TablaIcon({ size = 32, color = '#c49a3c' }) {
  const cx = size / 2, cy = size / 2;
  const r1 = size * 0.44;   // outer body ring
  const r2 = size * 0.34;   // dashed rim
  const r3 = size * 0.18;   // syahi fill
  const r4 = size * 0.085;  // inner ring on syahi
  const dot = size * 0.028; // lacing dot

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx={cx} cy={cy} rx={r1} ry={r1} stroke={color} strokeWidth={size*0.05}/>
      <ellipse cx={cx} cy={cy} rx={r2} ry={r2} stroke={color} strokeWidth={size*0.025}
        strokeDasharray={`${size*0.07} ${size*0.055}`} opacity="0.6"/>
      <ellipse cx={cx} cy={cy} rx={r3} ry={r3} fill={color} opacity="0.9"/>
      <ellipse cx={cx} cy={cy} rx={r4} ry={r4} stroke="#0e0e0d" strokeWidth={size*0.02} opacity="0.45"/>
      <circle cx={cx}      cy={cy-r1} r={dot} fill={color} opacity="0.45"/>
      <circle cx={cx}      cy={cy+r1} r={dot} fill={color} opacity="0.45"/>
      <circle cx={cx-r1}   cy={cy}    r={dot} fill={color} opacity="0.45"/>
      <circle cx={cx+r1}   cy={cy}    r={dot} fill={color} opacity="0.45"/>
    </svg>
  );
}
